import { BaseCategory } from "./BaseCategory";
import { FormatType, HeaderPositionType, TextStyleType } from "../constants";
import { SlideCategories } from "./CategoryController";
import { formatter } from "../formatter";
import { SlideModelBuilder } from "./SlideModelBuilder";

export class CompareValuesCategory extends BaseCategory {
    get name() {
        return "Compare Values";
    }

    get type() {
        return SlideCategories.COMPARE_VALUES;
    }

    get icon() {
        return null;
    }

    get description() {
        return "Use for comparing two or more numeric values. Do not use for more than 10 items.";
    }

    get slideTypes() {
        return [];
    }

    getPrompt() {
        return `Provide the data for a slide comparing numeric values. Each item should have a label and a numeric value.
        Based on the instructions in the content, provide a format for comparing the numbers (number, percent or percentage, or currency) and if currency, the currency type (USD, EUR, GBP, JPY).`;
    }

    getImagePrompt() {
        return false;
    }

    getPromptSchema() {
        return {
            format: "number | percent | currency",
            currencyFormat: "none | USD | EUR | GBP | JPY (only if format is currency)",
            items: [{
                label: "string",
                value: "number"
            }],
            conclusion: "an optional short conclusion or takeaway for the slide",
        };
    }

    getSlideModels(model) {
        // trim model items to max 10
        if (model.items && model.items.length > 10) {
            model.items = model.items.slice(0, 10);
        }

        let models = [
            this.buildPieChart(model, "compare_vertical_bars"),
            this.buildPieChart(model, "compare_horizontal_bars"),
            this.buildPieChartDashboard(model),
        ];

        if (model.items && model.items.length <= 4) {
            models.push(this.buildPieChart(model, "compare_circles")),
            models.push(this.buildPieChart(model, "compare_radial_bars"));
        }

        return models;
    }

    buildPieChart(model, templateId = "compare_vertical_bars") {
        let builder = new SlideModelBuilder(templateId, model);
        builder.createHeader({ heading: model.slideTitle, position: HeaderPositionType.TOP });
        builder.createPrimary({
            collectionColor: "colorful",
            format: builder.validateEnum(model.format, FormatType, FormatType.NUMBER),
            formatOptions: {
                currency: formatter.parseCurrencySymbol(model.currencyFormat || "USD"),
                abbreviated: "lower"
            },
            items: model.items?.map(item => ({
                value: item.value,
                text: builder.createSingleBlockText(item.label, TextStyleType.TITLE)
            })) || [],
        });
        if (model.conclusion) {
            builder.createBottomTray(model.conclusion);
        }
        return builder.model;
    }

    buildPieChartDashboard(model) {
        let builder = new SlideModelBuilder("dashboard", model);

        builder.createHeader({ heading: model.slideTitle, position: HeaderPositionType.LEFT });

        builder.createPrimary({
            items: [{
                componentType: "PieChart",
                childElement: {
                    collectionColor: "theme-to-dark",
                    data: model.items.map(item => ({ value: item.value, label: builder.createSingleBlockText(item.label) })),
                    format: "percent",
                    innerRadius: 0,
                    isDonut: false,
                    labelFormat: "percentage",
                    sortValues: true
                }
            }]
        });
        return builder.model;
    }
}
